import { isEqual } from 'lodash';

import { saveDoohAudience } from '@/services/doohAudience.service';

import type { DoohAudience, DoohAudienceEntity } from '@/services/doohAudience.service';

type PersistDoohAudienceParams = {
  current: DoohAudience;
  entity: DoohAudienceEntity;
  entityId: string;
  isDooh: boolean;
  saved: DoohAudience;
  userId: string;
};

export const EMPTY_DOOH_AUDIENCE: DoohAudience = { byAI: false, enableGenerateReport: false, variables: [] };

const normalizeText = (text?: string): string | undefined => text?.trim() || undefined;

const sortedVariables = (variables: string[]): string[] => [...variables].sort((a, b) => a.localeCompare(b));

/**
 * What the user can change: whether the report is generated and, while it is, the text and the variables (byAI is
 * only set by the save). A disabled audience is not saved, only that it is disabled.
 */
export const hasDoohAudienceChanges = (current: DoohAudience, saved: DoohAudience): boolean =>
  current.enableGenerateReport !== saved.enableGenerateReport ||
  (current.enableGenerateReport &&
    (normalizeText(current.text) !== normalizeText(saved.text) ||
      !isEqual(sortedVariables(current.variables), sortedVariables(saved.variables))));

/** Whether the audience is set up: its report is generated (no variable at all is the total population) */
export const isDoohAudienceConfigured = ({ enableGenerateReport }: DoohAudience): boolean => enableGenerateReport;

/** Saves the audience of a DOOH entity when it changed: the stored one (with the variables of the AI), else undefined */
export const persistDoohAudience = async ({
  current,
  entity,
  entityId,
  isDooh,
  saved,
  userId
}: PersistDoohAudienceParams): Promise<DoohAudience | undefined> =>
  isDooh && hasDoohAudienceChanges(current, saved) ? saveDoohAudience(entity, userId, entityId, current) : undefined;
